<template>
  <v-btn :loading="fetching" icon @click="refeshEvents">
    <v-icon>mdi-refresh</v-icon>
  </v-btn>
</template>

<script>
import { get } from 'vuex-pathify'

export default {
  name: 'EventRefetchButton',

  methods: {
    refeshEvents() {
      this.$eventBus.$emit('event/refetch')
    }
  },

  computed: {
    fetching: get('event/fetching')
  }
}
</script>
